import { render } from "./PlantPricesForOrganisation.vue?vue&type=template&id=19a87ca2"
import script from "./PlantPricesForOrganisation.vue?vue&type=script&lang=js"
export * from "./PlantPricesForOrganisation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__